import { ChartTypes } from './types';

export const CHARTS_OFFSETS: Record<
  ChartTypes,
  {
    offsetX: number;
    offsetY: number;
    leftSpacing?: number;
    rightSpacing?: number;
  }
> = {
  [ChartTypes.AstronautOverViewStatusChart]: { offsetX: 0, offsetY: 16 },
  [ChartTypes.AstronautOverviewLineChart]: { offsetX: 80, offsetY: 16 },
  [ChartTypes.ADELineChart]: {
    offsetX: 44,
    offsetY: 60,
  },
  [ChartTypes.ADEStatusChart]: {
    offsetX: 0,
    offsetY: 6,
  },
  [ChartTypes.VDELineChart]: {
    offsetX: 0,
    offsetY: 70,
    leftSpacing: 45,
    rightSpacing: 16,
  },
  [ChartTypes.KPITimeLine]: {
    offsetX: 42,
    offsetY: 76,
    rightSpacing: 8,
  },
  [ChartTypes.AstronautA5Next]: {
    offsetX: 148,
    offsetY: 58,
    leftSpacing: 38,
    rightSpacing: 2,
  },
  [ChartTypes.VectorSystem]: {
    offsetX: 148,
    offsetY: 58,
    leftSpacing: 62,
    rightSpacing: 38,
  },
  [ChartTypes.KPILineChart]: {
    offsetX: 8,
    offsetY: 0,
  },
  [ChartTypes.CardKpiLine]: {
    offsetX: 0,
    offsetY: 0,
  },
};

export const TOOLTIP_DEFAULT_WIDTH = 185;
export const TOOLTIP_ARROW_LEFT_MARGIN = 4;
export const TOOLTIP_ARROW_RIGHT_MARGIN = 12;
export const VDE_LINE_CHART_ARROW_OFFSET = 40;
export const KPI_LINE_CHART_ARROW_OFFSET = 45;
export const VECTOR_ALARMS_SUMMATION_TOOLTIP_HEIGHT = 120;
export const HEADER_HEIGHT_WITH_MARGIN = 60;
export const UPDATE_HISTORY_TOOLTIP_HEIGHT_ESTIMATE = 120;
export const UPDATE_HISTORY_TOOLTIP_VERTICAL_GAP = 10;
